import { render } from "./ListeBonLivraison.vue?vue&type=template&id=391f17bf&ts=true"
import script from "./ListeBonLivraison.vue?vue&type=script&lang=ts"
export * from "./ListeBonLivraison.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__